import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function LineItems({ items, onChange, testId, placeholder }) {
  const update = (i, v) => onChange(items.map((it, idx) => (idx === i ? v : it)));
  return (
    <div className="space-y-2" data-testid={`${testId}-list`}>
      {items.map((it, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="font-mono text-xs text-muted-foreground w-5">{i + 1})</span>
          <Input value={it} onChange={(e) => update(i, e.target.value)} placeholder={placeholder} data-testid={`${testId}-${i}`} />
          <button type="button" onClick={() => onChange(items.filter((_, idx) => idx !== i))} className="text-muted-foreground hover:text-red-400" data-testid={`${testId}-remove-${i}`} aria-label="Remove line"><Trash2 size={15} /></button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={() => onChange([...items, ""])} data-testid={`${testId}-add`}>
        <Plus size={14} /> Add line
      </Button>
    </div>
  );
}
